enum ExternalAgency
{
    Guiide = 0,
    PathLines = 5
}

export default ExternalAgency;
